import script from "./on-site-bill-lading-tip-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./on-site-bill-lading-tip-dialog.vue?vue&type=script&lang=ts&setup=true"

import "./on-site-bill-lading-tip-dialog.vue?vue&type=style&index=0&id=2fbeb14b&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fbeb14b"]])

export default __exports__